import React from "react";
import { useNavigate } from "react-router-dom";
import BookDemoModal from "./BookDemoModal";
import "../styles/marketing.css";
import Seo from "../components/marketing/Seo";

/** Public, shareable demo-booking page — https://<domain>/book-demo */
export default function BookDemoPage() {
  const navigate = useNavigate();
  return (
    <div className="mk min-h-screen bg-gradient-to-b from-blue-50/70 via-white to-slate-50/40 relative overflow-hidden" data-testid="book-demo-page">
      <Seo
        title="Book a Demo | Fieldz AI Field Service Software"
        description="Book a personalized walkthrough of Fieldz AI: scheduling, dispatch, business phone, invoicing, payments, and multi-location reporting — live with our team."
        path="/book-demo"
      />
      <div className="absolute top-6 left-6 z-[101]">
        <button onClick={() => navigate("/")} data-testid="book-demo-logo">
          <img src="/logo-dark.png" alt="Fieldz AI" className="h-9 object-contain" />
        </button>
      </div>
      <BookDemoModal isOpen={true} onClose={() => navigate("/")} isDark={false} showShareLink={false} />
    </div>
  );
}
